/** Recognize the SDK's handshake without reconstructing its session identity or payload. */
export const isBrowserSessionReady = (data: string): boolean => {
  try {
    const packet = JSON.parse(data);
    return (
      packet?.type === 'session_ready' &&
      typeof packet.sessionId === 'string' &&
      packet.sessionId.length > 0
    );
  } catch {
    return false;
  }
};
